import { useContext } from "react"
import { useMutation } from "react-apollo"

import { SessionContext } from "contexts/session"

import { queryOptions } from "utils/helper"

import SET_TEMPORARY_PASSWORD from "../../graphql/UserManagement/mutations/setTemporaryPassword"

const useSetTemporaryPasswordMutation = options => {
  const { user } = useContext(SessionContext)

  return useMutation(SET_TEMPORARY_PASSWORD, {
    ...queryOptions(user, true),
    ...options,
    refetchQueries: ['FindOneUser'],
  });
}

export default useSetTemporaryPasswordMutation
